<template>
    <v-dialog v-model="showDialog" max-width="500">
        <div tabindex="0" @keydown.stop.prevent></div>
        <v-card>
            <v-card-text>
                <v-card-title class="headline primary--text"
                    >Relatório via e-mail</v-card-title
                >
                <v-spacer></v-spacer>
                <v-form ref="formEmail" v-model="validEmail" @submit.prevent>
                    <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="E-mail"
                        type="email"
                        v-model="emailReport"
                        :rules="emailRules"
                        required
                        data-cy="emailFieldforReport"
                        @keyup.enter="exportarEmailSQS()"
                    >
                    </v-text-field>
                </v-form>
                <v-card-subtitle
                    >Digite o e-mail onde deseja receber o
                    relatório</v-card-subtitle
                >
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="exportarEmailSQS()"
                    :disabled="!validEmail"
                    data-cy="btnSubmitReport"
                >
                    Enviar
                    <v-icon class="ml-1">chevron_right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style></style>

<script>
export default {
    name: 'RelatorioEmailModal',
    props: {
        modelRelatorioXlsEmail: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            showDialog: this.modelRelatorioXlsEmail,
            emailReport: '',
            validEmail: false,
            emailRules: [
                v => !!v || 'E-mail é requerido',
                v => /.+@.+/.test(v) || 'E-mail inválido'
            ]
        };
    },
    methods: {
        checkForm() {
            return this.$refs.formEmail?.validate?.() ?? false;
        },
        exportarEmailSQS() {
            if (this.checkForm()) {
                this.$emit('exportarXlsSQS', this.emailReport);
                this.$emit('fecharModal', false);
            }
        }
    },
    watch: {
        modelRelatorioXlsEmail(newVal) {
            if (newVal) {
                this.emailReport = '';
                this.validEmail = false;
            }
        },
        showDialog(val) {
            this.$emit('fecharModal', val);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.formEmail.resetValidation();
        });
    },
    beforeDestroy() {
        this.$refs.formEmail.resetValidation();
    }
};
</script>
